import { HttpStatusCode } from '@angular/common/http';

import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { actionClearMsg, actionDeleteAllProductWishList, actionDeleteProductWishList, countPdtWishList, loadPdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';
import { SetCommaPipe } from '@app/pipes/set-comma.pipe';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { getMsgDeleteProductWishListResult, getPdtWishList, getTotalPdtWishList, PdtWishListState } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { getSmWownet, getSmWownetConfig, getWowWord, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState, getWAlertStatus } from '@app/selectors/w-alert.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { ProductService } from '@app/services/shoppingmall/product.service';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PaginationInstance } from 'ngx-pagination';
import { Observable, Subscription } from 'rxjs';
import { SmWownetConfigModel } from '@app/models/system/sm-wownet-config.model';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';

@Component({
  selector: 'app-wish-list-pdt',
  templateUrl: './wish-list-pdt.component.html',
  styleUrls: ['./wish-list-pdt.component.css'],
  providers: [SetCommaPipe]
})
export class WishListPdtComponent implements OnInit, OnDestroy, AfterContentChecked {
  smWownet$ = new Observable<SmWownetModel>();

  smConfig$ = new Observable<SmWownetConfigModel>();

  wAlertStatus$ = new Observable<WAlertStatus>();

  deleteProductWishListStatus$ = new Observable<Map<String, String>>();

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  total$ = new Observable<number>();
  total: number = 0;

  smWowWord$ = new Observable<WownetWordModel>();
  smWowWord: any = {} as WownetWordModel;

  subscription$ = {} as Subscription

  member = AuthUtil.getLoginedInfo();

  sortCd: string = "";
  pathKind: string = "PC";
  urlWownet: string = "";
  lshowPdtYn: string = "";
  key: string = "";

  page: number = 1;
  len: number = 8;

  isLogin: boolean = AuthUtil.isLogined();
  isPv1: boolean = false;
  isPv2: boolean = false;
  isPv3: boolean = false;
  checkAll : boolean = false;
  checkboxMap : Map<OrdPdtModel, String> = new Map();

  config: PaginationInstance = {
    id: "main-products",
    itemsPerPage: this.len,
    currentPage: this.page,
    totalItems: this.total,
  }

  constructor(
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _pdtWishListStore: Store<PdtWishListState>,
    private _smWownetStore: Store<SmWownetState>,
    private _deviceService: DeviceDetectorService,
    private _wAlertStore: Store<WAlertState>,
    private _translateService : TranslateService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.smWownet$ = this._smWownetStore.select(getSmWownet);
    this.total$ = this._pdtWishListStore.select(getTotalPdtWishList);
    this.products$ = this._pdtWishListStore.select(getPdtWishList);
    this.smWowWord$ = this._smWownetStore.select(getWowWord);
    this.smConfig$ = this._smWownetStore.select(getSmWownetConfig);
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
    this.deleteProductWishListStatus$ = this._pdtWishListStore.select(getMsgDeleteProductWishListResult)
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnInit(): void {
    this.checkboxMap = new Map();
    this.pathKind = this._deviceService.isDesktop() ? 'PC' : 'PHONE';

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));

    this.subscription$ = this.smWownet$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.urlWownet = ConvertUtil.convertToString(res.urlWownet);
        this.lshowPdtYn = ConvertUtil.convertToString(res.lShowPdtYn);
      }
    });

    this.loadProducts();
    this.loadTotalProduct();
    this.page = 1;
    this.config.currentPage = 1;

    this.total$.subscribe(res => {
      this.total = res;
      this._pdtWishListStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.products$.subscribe(res => {
      this.products = res;
      this._pdtWishListStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.smConfig$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.isPv1 = res.oUsePv1 === "Y";
        this.isPv2 = res.oUsePv2 === "Y";
        this.isPv3 = res.oUsePv3 === "Y";
      }
    });

    this.smWowWord$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
         this.smWowWord = res;
      }
    });

    this.deleteProductWishListStatus$.subscribe(res => {
      if(res !== null && res !== undefined && res.size !== 0) {
        if(Number(res.get("code")) === HttpStatusCode.Ok) {
          this.loadProducts();
          this.loadTotalProduct();
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: this._translateService.instant("msg.wishlist.lbl.003")} }));
        } else {
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: this._translateService.instant("msg.wishlist.lbl.004")} }));
        }
        this._pdtWishListStore.dispatch(actionClearMsg({msgDeleteWishList : new Map()}))
        this._wAlertStore.dispatch(setShowOverlayLoading({ loading: false }));
      }
    });
  }

  ngOnDestroy(): void {
    let hasValue = this.subscription$.closed != undefined;
    if(this.subscription$ && hasValue) {
      this.subscription$.unsubscribe();
    }
  }

  loadTotalProduct(): void {
    const params = this.getParams();

    if (params.page < 0) return;

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtWishListStore.dispatch(countPdtWishList({ params: params }));
  }

  loadProducts(): void {
    const params = this.getParams();

    if (params.page < 0) return;

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtWishListStore.dispatch(loadPdtWishList({ params: params }));
  }

  handleOnChangePage(page: number): void {
    if(this.total > this.len) {
      this.page = page;
      this.config.currentPage = page;

      this.loadProducts();
    }
  }

  getParams(): any {
    let member = AuthUtil.getLoginedInfo();
    let userid = '';
    if (member) {
      userid = ConvertUtil.convertToSring(member.userid);
    }

    const params = {
      comId: environment.comId,
      cateCd: "",
      pathKind: this.pathKind,
      key: this.key,
      page: this.page - 1,
      len: this.len,
      userid: userid
    }

    return params;
  }

  handleOnTotalPage(totalPage: number): void {
    this.total = totalPage;
  }

  onChangeLen(selected : SelectDropdownModel) {
    this.len = Number(selected.value);
    this.loadProducts();
  }

  changeWish(){
    this.loadTotalProduct();
    this.loadProducts();
  }












}
